<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("home.partnership_programmer_title") }}</h2>
    <div class="row">
      <div class="col-12 col-sm-12 col-lg-8 col-xl-6">
        <div>
          <StatusMessage ref="statusMessageSuccess"></StatusMessage>

          <div ref="eleName" class="mb-3 required">
            <label for="partProg_name">{{ $t("partnership.name") }}: *</label>
            <input
              id="partProg_name"
              v-model.trim="partProg_name"
              type="text"
              class="form-control"
              :placeholder="$t('partnership.name_placeholder')"
              maxlength="40"
              required
            />
          </div>
          <StatusMessage ref="statusMessageName"></StatusMessage>

          <div ref="eleEmail" class="mb-3 required">
            <label for="partProg_email">{{ $t("partnership.email") }}: *</label>
            <input
              id="partProg_email"
              v-model.trim="partProg_email"
              type="email"
              class="form-control"
              placeholder="name@example.com"
              maxlength="60"
              required
            />
          </div>
          <StatusMessage ref="statusMessageEMail"></StatusMessage>

          <div ref="elePhone" class="mb-3 required">
            <label for="partProg_phone">{{ $t("partnership.phone") }}: *</label>
            <input
              id="partProg_phone"
              v-model.trim="partProg_phone"
              type="tel"
              class="form-control"
              placeholder="+359..."
              maxlength="30"
              required
            />
          </div>
          <StatusMessage ref="statusMessagePhone"></StatusMessage>

          <div ref="eleDescription" class="mb-3 required">
            <label for="partProg_description">{{ $t("partnership.project_description") }}: *</label>
            <textarea
              id="partProg_description"
              v-model.trim="partProg_description"
              class="form-control"
              rows="5"
              maxlength="1000"
              required
            ></textarea>
          </div>
          <StatusMessage ref="statusMessageDescription"></StatusMessage>

          <div ref="elePlatform" class="mb-3 required">
            <label for="partProg_platform">{{ $t("partnership.development_platform") }}: *</label>
            <input
              id="partProg_platform"
              v-model.trim="partProg_platform"
              type="text"
              class="form-control"
              maxlength="200"
              required
            />
          </div>
          <StatusMessage ref="statusMessagePlatform"></StatusMessage>

          <div ref="eleGitLink" class="mb-3">
            <label for="partProg_git">{{ $t("partnership.git_link") }}:</label>
            <input
              id="partProg_git"
              v-model.trim="partProg_git"
              type="url"
              class="form-control"
              placeholder="https://"
            />
          </div>
          <StatusMessage ref="statusMessageGitLink"></StatusMessage>

          <div class="mb-3 mb-0">
            <label>
              {{ $t("partnership.attach_files") }}<br />
              ({{ $t("partnership.allowed_formats") }})
            </label>
          </div>

          <div class="input-group mb-3">
            <div class="custom-file">
              <input
                id="file1"
                ref="partProg_file1"
                type="file"
                class="custom-file-input"
                @change="fileSetName($event, 1)"
              />
              <label for="file1" class="custom-file-label" v-text="file1"></label>
            </div>
          </div>
          <StatusMessage ref="statusMessageFile1"></StatusMessage>

          <div class="input-group mb-3">
            <div class="custom-file">
              <input
                id="file2"
                ref="partProg_file2"
                type="file"
                class="custom-file-input"
                @change="fileSetName($event, 2)"
              />
              <label for="file2" class="custom-file-label" v-text="file2"></label>
            </div>
          </div>
          <StatusMessage ref="statusMessageFile2"></StatusMessage>

          <div class="input-group mb-3">
            <div class="custom-file">
              <input
                id="file3"
                ref="partProg_file3"
                type="file"
                class="custom-file-input"
                @change="fileSetName($event, 3)"
              />
              <label for="file3" class="custom-file-label" v-text="file3"></label>
            </div>
          </div>
          <StatusMessage ref="statusMessageFile3"></StatusMessage>

          <div ref="eleCaptcha" class="mb-3">
            <ReCaptcha ref="recaptcha"></ReCaptcha>
          </div>
          <StatusMessage ref="statusMessageRobot"></StatusMessage>

          <button
            type="button"
            class="btn btn-primary btn-block"
            :class="{ disabled: submitDisabled }"
            @click="formSubmit"
          >
            {{ $t("partnership.send") }}
          </button>

          <StatusMessage ref="statusMessageSubmit"></StatusMessage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StatusMessage from "../shared/StatusMessage.vue";
  import ReCaptcha from "./ReCaptcha.vue";

  export default {
    name: "PartnershipProgrammerSection",
    components: {
      StatusMessage,
      ReCaptcha,
    },
    data() {
      return {
        submitDisabled: false,

        fileDefault: "Choose file",
        file1: "",
        file2: "",
        file3: "",
        partProg_name: "",
        partProg_email: "",
        partProg_phone: "",
        partProg_description: "",
        partProg_platform: "",
        partProg_git: "",
        fileTypesAllowed: [
          "application/zip", // zip
          "application/x-zip-compressed", // zip
          "application/pdf", // pdf
          "application/ods", // ods
          "application/vnd.oasis.opendocument.spreadsheet", // ods
        ],
      };
    },
    created() {
      this.fileDefault = this.$t("common.choose_file");
      this.file1 = this.fileDefault;
      this.file2 = this.fileDefault;
      this.file3 = this.fileDefault;
    },
    methods: {
      scrollTo(refName) {
        this.$root.scrollTo(
          0,
          this.$refs[refName].offsetTop + this.$refs[refName].offsetParent.offsetTop
        );
      },
      fileSetName(event, objectid) {
        if (event.target.files.length > 0) {
          if (this.fileTypesAllowed.indexOf(event.target.files[0].type) < 0) {
            this.resetFileInput("partProg_file" + objectid);
            this["file" + objectid] = this.fileDefault;
            this.$refs["statusMessageFile" + objectid].displayErrorMessage("file");
          } else {
            this["file" + objectid] = event.target.files[0].name;
            this.$refs["statusMessageFile" + objectid].resetStatusMessage();
          }
        } else {
          this["file" + objectid] = this.fileDefault;
          this.$refs["statusMessageFile" + objectid].resetStatusMessage();
        }
      },
      formSend(formData) {
        this.$root.request
          .post("/partnership_programmer", formData)
          .catch(this.$root.responseErrorHandler)
          .then(this.$root.responseMiddleware)
          .then((response) => {
            // console.dir(response);

            this.submitDisabled = false;

            if (response.success) {
              this.$root.scrollToTop();
              this.$refs.statusMessageSuccess.displaySuccessMessage("contact_us_sent");
              this.resetForm();
            } else if (response.error && response.error.message) {
              this.$refs.statusMessageSubmit.displayErrorMessage(response.error.message);
            }
          });
      },
      formSubmit() {
        if (this.submitDisabled) {
          return;
        }

        // Name
        if (this.partProg_name == "") {
          this.scrollTo("eleName");
          this.$refs.statusMessageName.displayErrorMessage("required", {
            attribute: this.$t("partnership.name"),
          });
          return;
        }
        this.$refs.statusMessageName.resetStatusMessage();

        // EMail
        if (this.partProg_email == "") {
          this.scrollTo("eleEmail");
          this.$refs.statusMessageEMail.displayErrorMessage("required", {
            attribute: this.$t("partnership.email"),
          });
          return;
        }
        if (!this.$root.isEmailValid(this.partProg_email)) {
          this.scrollTo("eleEmail");
          this.$refs.statusMessageEMail.displayErrorMessage("invalid_email");
          return;
        }
        this.$refs.statusMessageEMail.resetStatusMessage();

        // Phone
        if (this.partProg_phone == "") {
          this.scrollTo("elePhone");
          this.$refs.statusMessagePhone.displayErrorMessage("required", {
            attribute: this.$t("partnership.phone"),
          });
          return;
        }
        this.$refs.statusMessagePhone.resetStatusMessage();

        // Description
        if (this.partProg_description == "") {
          this.scrollTo("eleDescription");
          this.$refs.statusMessageDescription.displayErrorMessage("required", {
            attribute: this.$t("partnership.project_description"),
          });
          return;
        }
        this.$refs.statusMessageDescription.resetStatusMessage();

        // Platform
        if (this.partProg_platform == "") {
          this.scrollTo("elePlatform");
          this.$refs.statusMessagePlatform.displayErrorMessage("required", {
            attribute: this.$t("partnership.development_platform"),
          });
          return;
        }
        this.$refs.statusMessagePlatform.resetStatusMessage();

        // GitHub/BitBucket url
        if (this.partProg_git.length > 0) {
          var isValidGitUrl = this.$root.isValidGitUrl(this.partProg_git);
          if (!isValidGitUrl) {
            this.scrollTo("eleGitLink");
            this.$refs.statusMessageGitLink.displayErrorMessage("invalid_git_link");
            return;
          }
        }
        this.$refs.statusMessageGitLink.resetStatusMessage();

        // ReCaptcha
        if (
          typeof this.$refs.recaptcha.verifyKey !== "string" ||
          this.$refs.recaptcha.verifyKey.length < 200
        ) {
          this.$refs.recaptcha.resetRecaptcha();
          this.scrollTo("eleCaptcha");
          this.$refs.statusMessageRobot.displayErrorMessage("recaptcha");
          return;
        }
        this.$refs.statusMessageRobot.resetStatusMessage();

        // Form Data
        var formData = new FormData();
        formData.set("partProg_name", this.partProg_name);
        formData.set("partProg_email", this.partProg_email);
        formData.set("partProg_phone", this.partProg_phone);
        formData.set("partProg_description", this.partProg_description);
        formData.set("partProg_platform", this.partProg_platform);
        formData.set("partProg_git", this.partProg_git);
        formData.set("partProg_captcha", this.$refs.recaptcha.verifyKey);

        // File(s)
        for (var i = 1; i < 4; i++) {
          var object = "partProg_file" + i;
          var status = "statusMessageFile" + i;
          if (this.$refs[object].files.length > 0) {
            if (this.fileTypesAllowed.indexOf(this.$refs[object].files[0].type) < 0) {
              this.$refs[status].displayErrorMessage("file_name", {
                name: this.$refs[object].files[0].name,
              });
              return;
            }
            this["file" + i] = this.$refs[object].files[0].name;
            formData.set(object, this.$refs[object].files[0]);
          }
        }

        this.submitDisabled = true;

        this.formSend(formData);
      },
      resetFileInput(object) {
        this.$refs[object].value = "";
        this.$refs[object].type = "text";
        this.$refs[object].type = "file";
      },
      resetForm() {
        this.partProg_name = "";
        this.partProg_email = "";
        this.partProg_phone = "";
        this.partProg_description = "";
        this.partProg_platform = "";
        this.partProg_git = "";

        this.file1 = this.file2 = this.file3 = this.fileDefault;

        // tricky reset of the file input field
        for (var i = 1; i < 4; i++) {
          this.resetFileInput("partProg_file" + i);
        }

        this.$refs.recaptcha.resetRecaptcha();
      },
    },
  };
</script>
